export default "__VITE_ASSET__zC3EaP1z__"